module.exports = __webpack_public_path__ + "img/meyro.0e3da47c.png";